import { render, staticRenderFns } from "./ClassInput.vue?vue&type=template&id=1b0925e0&"
import script from "./ClassInput.vue?vue&type=script&lang=ts&"
export * from "./ClassInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports